import { Directive, Input, TemplateRef, ViewContainerRef } from "@angular/core";
import { IdentityStorage } from "../../../core/auth/_models/identity.storage";

@Directive({
  selector: "[appRoles]",
  inputs: ["appRoles"],
})
export class RolesDirective {
  constructor(
    private _templateRef: TemplateRef<any>,
    private _viewContainer: ViewContainerRef,
    private identityStorage: IdentityStorage
  ) {}

  @Input() set appRoles(allowedRoles: Array<string>) {
    let shouldShow: boolean = false;
    let userRoles: Array<string> = this.identityStorage.getGroups();

    for (let role of userRoles) {
      for (let allowedRole of allowedRoles) {
        const allowedRoleUp = allowedRole.toUpperCase();
        if (role.toUpperCase() == allowedRoleUp) {
          shouldShow = true;
          break;
        }
      }
    }

    if (shouldShow) {
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else {
      this._viewContainer.clear();
    }
  }
}
